<script setup lang="ts">
defineEmits(['click-link']);
defineProps<{
  title?: string;
  message: string;
  link?: string;
}>();
</script>

<template>
  <div class="rounded-md bg-orange-50 p-4">
    <div class="flex">
      <div class="flex-shrink-0">
        <ui-icon class="h-5 w-5 text-orange-400" name="Info" />
      </div>
      <div class="ml-3 flex-1 md:flex md:justify-between">
        <div>
          <p v-if="title" class="text-sm font-semibold text-orange-700">
            {{ title }}
          </p>
          <p class="text-sm text-orange-700">
            {{ message }}
          </p>
        </div>

        <div v-if="link" class="mt-3 text-sm md:ml-6 md:mt-0">
          <p class="whitespace-nowrap cursor-pointer font-semibold text-orange-700 hover:text-orange-600" @click="$emit('click-link')">
            {{ link }}
            <span aria-hidden="true"> &rarr;</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
